var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSociiPlusStartups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1147",
    "data-name": "Rectangle 1147",
    width: 8.755,
    height: 8.679,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232",
    transform: "translate(-367 -31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_30",
    "data-name": "Polygon 30",
    d: "M11.745,0A3,3,0,0,1,14.36,1.529l2.812,5a3,3,0,0,1,0,2.942l-2.812,5A3,3,0,0,1,11.745,16H6.255A3,3,0,0,1,3.64,14.471l-2.812-5a3,3,0,0,1,0-2.942l2.813-5A3,3,0,0,1,6.255,0Z",
    transform: "translate(367 31)",
    fill: "#bf360c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231",
    transform: "translate(371.623 34.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M1.214,3.551l1.149.488q.2-.39.417-.77t.472-.726L2.4,2.37Zm1.67.878L4.326,5.871a8.521,8.521,0,0,0,1.16-.64,5.638,5.638,0,0,0,.878-.694,6.1,6.1,0,0,0,1.29-1.8A5.428,5.428,0,0,0,8.1.657,5.427,5.427,0,0,0,6.017,1.1a6.1,6.1,0,0,0-1.8,1.29,5.637,5.637,0,0,0-.694.878,8.522,8.522,0,0,0-.64,1.16M5.366,3.389a.729.729,0,0,1-.217-.537.753.753,0,1,1,1.507,0,.759.759,0,0,1-1.29.537M5.2,7.541,6.385,6.359,6.212,5.5q-.347.249-.726.472t-.77.417ZM8.738.017a6.268,6.268,0,0,1-.369,2.689A6.59,6.59,0,0,1,6.83,4.993l-.022.022-.022.022.239,1.193a.616.616,0,0,1-.016.314.67.67,0,0,1-.168.271L4.987,8.679,4.065,6.533,2.222,4.69.076,3.768,1.941,1.914a.67.67,0,0,1,.271-.168.616.616,0,0,1,.314-.016l1.193.239a.085.085,0,0,1,.022-.016.085.085,0,0,0,.022-.016A6.659,6.659,0,0,1,6.049.391,6.213,6.213,0,0,1,8.738.017M.8,6a1.28,1.28,0,0,1,.927-.385,1.242,1.242,0,0,1,.927.374,1.242,1.242,0,0,1,.374.927,1.28,1.28,0,0,1-.385.927,2.115,2.115,0,0,1-.873.466A11.813,11.813,0,0,1,0,8.657,12.659,12.659,0,0,1,.341,6.879,2.075,2.075,0,0,1,.8,6m.455.466a1.436,1.436,0,0,0-.271.51,5.453,5.453,0,0,0-.206.889A5.451,5.451,0,0,0,1.67,7.66a1.436,1.436,0,0,0,.51-.271.61.61,0,0,0,.211-.461.649.649,0,0,0-.672-.672.61.61,0,0,0-.461.211",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociiPlusStartups);
export default __webpack_public_path__ + "static/media/socii-plus-startups.ec52b3dc236cfdbdb29100d8cbb9c4f5.svg";
export { ForwardRef as ReactComponent };